import competitionTrainersList from '@/store/modules/competitions-trainers/competition-trainers-list'
import competitionTrainersDelete from '@/store/modules/competitions-trainers/competitions-trainers-delete'
import competitionTrainersAdd from '@/store/modules/competitions-trainers/competitions-trainers-add'

export default {
  competitionTrainersList,
  competitionTrainersDelete,
  competitionTrainersAdd,
}
